<template>
  <i-modal
    class="modal-new-property"
    v-model="modal"
    title="物件新規登録"
    width="880"
    :mask-closable="false"
    :scrollable="true"
    lock-scroll
    footer-hide
    @on-visible-change="onVisibleChange"
  >
    <div class="container">
      <i-tabs v-model="tab" type="card">
        <i-tab-pane label="居住用" name="residence" class="residence">
          <div class="panel__wrap">
            <div class="panel mansion">
              <div class="panel__title">マンション</div>
              <ul class="list-link">
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1001)">
                    新築マンション<template v-if="showSubdivisionMenu">（1部屋）</template>
                  </span>
                </li>
                <li v-if="showSubdivisionMenu" class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1011)">新築マンション（分譲）</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1021)">中古マンション</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1002)">
                    新築タウンハウス<template v-if="showSubdivisionMenu">（1部屋）</template>
                  </span>
                </li>
                <li v-if="showSubdivisionMenu" class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1012)">新築タウンハウス（分譲）</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1022)">中古タウンハウス</span>
                </li>
              </ul>
            </div>
            <div class="panel house">
              <div class="panel__title">戸建て</div>
              <ul class="list-link">
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1101)">
                    新築戸建て
                    <template v-if="showSubdivisionMenu">（1戸）</template>
                  </span>
                </li>
                <li v-if="showSubdivisionMenu" class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1111)">新築戸建て（分譲）</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1121)">中古戸建</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1102)">
                    新築テラスハウス<template v-if="showSubdivisionMenu">（1戸）</template>
                  </span>
                </li>
                <li v-if="showSubdivisionMenu" class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1112)">新築テラスハウス（分譲）</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1122)">中古テラスハウス</span>
                </li>
              </ul>
            </div>
            <div class="panel land">
              <div class="panel__title">土地</div>
              <ul class="list-link">
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1201)">売地</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1202)">借地権</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(1203)">底地権</span>
                </li>
              </ul>
            </div>
          </div>
        </i-tab-pane>
        <i-tab-pane label="事業・投資用" name="investment" class="investment">
          <div class="panel__wrap">
            <div class="panel building_all">
              <div class="panel__title">建物全部（全部所有）</div>
              <div class="list-link__wrap">
                <ul class="list-link">
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2101)">店舗</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2102)">店舗付住宅</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2103)">賃貸併用住宅</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2104)">事務所</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2105)">店舗事務所</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2106)">ビル</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2107)">マンション</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2108)">アパート</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2109)">戸建賃貸</span>
                  </li>
                </ul>
                <ul class="list-link">
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2110)">倉庫</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2111)">工場</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2112)">ホテル</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2113)">別荘・保養所</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2201)">駐車場</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2202)">土地</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2203)">別荘地・土地</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2301)">軍用地</span>
                  </li>
                  <li class="list-link__item">
                    <span class="list-link__btn" @click="onClickMenu(2199)">その他</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="panel building_partial">
              <div class="panel__title">建物一部（区分所有）</div>
              <ul class="list-link">
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(2001)">店舗</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(2002)">事務所</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(2003)">店舗事務所</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(2004)">マンション</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(2005)">リゾートマンション</span>
                </li>
                <li class="list-link__item">
                  <span class="list-link__btn" @click="onClickMenu(2099)">その他</span>
                </li>
              </ul>
            </div>
          </div>
        </i-tab-pane>
      </i-tabs>
    </div>
  </i-modal>
</template>

<script>
import { Modal, Tabs, TabPane } from 'view-design'
import { isResidence, isInvestment } from '@/util/m_b_type.js'
import { SUBDIVISION_MENU_VISIBLE_SHOP_IDS } from '@/constants/shop_features'
const EDITOR_DOMAIN = process.env.VUE_APP_EDITOR_DOMAIN
export default {
  components: {
    'i-modal': Modal,
    'i-tabs': Tabs,
    'i-tab-pane': TabPane,
  },
  data() {
    return {}
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalNewPropertyLinkList/getModal']
      },
      set(val) {
        this.$store.commit('ModalNewPropertyLinkList/setModal', val)
      },
    },
    tab: {
      get() {
        return this.$store.getters['ModalNewPropertyLinkList/getTab']
      },
      set(val) {
        this.$store.commit('ModalNewPropertyLinkList/setTab', val)
      },
    },
    shopId() {
      const user = this.$store.getters['User/getUser']
      return user.shop_id
    },
    showSubdivisionMenu() {
      return SUBDIVISION_MENU_VISIBLE_SHOP_IDS.includes(this.shopId)
    },
  },
  methods: {
    // モーダル開閉時処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // モーダル起動処理
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    // メニュークリック処理
    onClickMenu(categoryId) {
      let type = ''
      if (isResidence(categoryId)) type = 'residence'
      if (isInvestment(categoryId)) type = 'investment'
      window.open(`${EDITOR_DOMAIN}/edit/${type}/new/regulars/${categoryId}`, '_blank')
    },
    // パラメータリセット
    resetParams() {
      // iviewモーダルが起動された際、bodyに付与されるstyle`overflow:hidden`が残るケースがあるので、
      // 動的にvisibleを付与する
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      // パラメータリセット
      this.$store.dispatch('ModalNewPropertyLinkList/reset')
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/sass/_variables.scss';
.modal-new-property {
  .container {
  }
  .panel {
    width: 260px;
    height: 100%;
    min-height: 390px;
    padding: 8px 16px;
    border-radius: 4px;
    &__wrap {
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      padding: 16px 0;
    }
    &__title {
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: bold;
    }
    .list-link {
      list-style: none;
      &__item {
        margin-bottom: 8px;
      }

      &__btn {
        display: inline-block;
        width: 100%;
        padding: 6px 16px;
        border-radius: 4px;
        font-weight: bold;
        color: #fff;
        cursor: pointer;
        transition: all 0.4s ease;
        &:hover {
          opacity: 0.8;
        }
      }
    }

    &.mansion {
      background-color: #aed6fa;
      .list-link__btn {
        background-color: #1f80f0;
      }
    }
    &.house {
      background-color: #b8dd93;
      .list-link__btn {
        background-color: #7bba3a;
      }
    }
    &.land {
      background-color: #fec26e;
      .list-link__btn {
        background-color: #f16708;
      }
    }
    &.building_all {
      width: 520px;
      background-color: #aed6fa;
      .list-link {
        width: 220px;
        &__wrap {
          display: flex;
          align-items: flex-start;
          justify-content: space-around;
        }
      }
      .list-link__btn {
        background-color: #1f80f0;
      }
    }
    &.building_partial {
      background-color: #b8dd93;
      .list-link__btn {
        background-color: #7bba3a;
      }
    }
  }

  .residence {
    .panel__wrap {
      background-color: $residence-bg-color;
    }
  }
  .investment {
    .panel__wrap {
      background-color: $investment-bg-color;
    }
  }
}
</style>
<style lang="scss">
.modal-new-property {
  .ivu-tabs-bar {
    border-bottom: none;
    margin-bottom: 0;
  }

  .ivu-tabs .ivu-tabs-tabpane {
    height: 422px;
  }

  .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
    font-size: 14px;
    &:first-child {
      background: #000;
    }
  }
  .ivu-tabs-tab {
    &:first-child {
      background: #000;
    }
  }
}
</style>
